import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LaptopSafeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LaptopSafeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.8469 16.2791H5.1532C4.93993 16.2791 4.76709 16.1063 4.76709 15.893V7.04471C4.76709 6.83144 4.93994 6.6586 5.1532 6.6586H18.4481C18.6614 6.6586 18.8342 6.83145 18.8342 7.04471C18.8342 7.25783 18.6614 7.43082 18.4481 7.43082H5.53931V15.5069H18.4608V7.43082H17.968C17.7548 7.43082 17.5819 7.25782 17.5819 7.04471C17.5819 6.83144 17.7548 6.6586 17.968 6.6586H18.8469C19.0602 6.6586 19.233 6.83145 19.233 7.04471V15.893C19.233 16.1063 19.0601 16.2791 18.8469 16.2791Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.4985 17.0849H20.8341V6.19404C20.8341 5.5654 20.3234 5.05411 19.6957 5.05411H4.30464C3.67691 5.05411 3.16621 5.56541 3.16621 6.19404V17.0849H2.50183C2.28856 17.0849 2.11572 17.2578 2.11572 17.4711V18.4449C2.11572 19.1181 2.66352 19.6659 3.33665 19.6659H20.6637C21.337 19.6659 21.8846 19.1181 21.8846 18.4449V17.4711C21.8846 17.2578 21.7118 17.0849 21.4985 17.0849ZM3.93844 6.19404C3.93844 5.99133 4.10284 5.82633 4.30464 5.82633H19.6956C19.8975 5.82633 20.0618 5.99133 20.0618 6.19404V17.0849H3.93844V6.19404ZM21.1124 18.4449C21.1124 18.6923 20.9111 18.8936 20.6637 18.8936H3.33664C3.08929 18.8936 2.88794 18.6923 2.88794 18.4449V17.8572H21.1124V18.4449Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0079 15.1188H11.9925C11.9271 15.1188 11.8628 15.1023 11.8055 15.0706C11.4909 14.8964 11.0185 14.6178 10.5544 14.2788C10.1119 13.9555 9.7528 13.6347 9.48719 13.3257C9.21299 13.0064 9.06201 12.5915 9.06201 12.1573V9.22568C9.06201 9.03459 9.20182 8.87215 9.39081 8.84379C10.3412 8.70126 11.1155 8.54229 11.7123 7.91275C11.7853 7.83598 11.8865 7.79239 11.9925 7.79239H12.0079C12.1139 7.79239 12.2151 7.83598 12.2881 7.91275C12.885 8.54229 13.6593 8.70141 14.6096 8.84379C14.7986 8.87215 14.9384 9.03458 14.9384 9.22568V12.1573C14.9384 12.5915 14.7875 13.0064 14.5133 13.3257C14.2477 13.6347 13.8885 13.9555 13.4459 14.2788C12.9819 14.6178 12.5094 14.8964 12.1948 15.0706C12.1376 15.1023 12.0734 15.1188 12.0079 15.1188ZM9.83423 9.55553V12.1573C9.83423 12.407 9.91899 12.6432 10.073 12.8225C10.2291 13.0041 10.5182 13.296 11.0101 13.6552C11.3613 13.9118 11.7198 14.1325 12.0002 14.2938C12.2808 14.1325 12.6393 13.9118 12.9905 13.6552C13.4824 13.296 13.7715 13.0041 13.9275 12.8224C14.0815 12.6432 14.1664 12.4069 14.1664 12.1573V9.55553C13.3804 9.4228 12.631 9.22356 12.0002 8.6996C11.3695 9.22357 10.6202 9.42296 9.83423 9.55553Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 12.6516C11.9211 12.6516 11.8419 12.6276 11.7737 12.5783L10.7027 11.8027C10.53 11.6777 10.4913 11.4362 10.6163 11.2635C10.7415 11.0908 10.9828 11.0522 11.1555 11.1772L11.9377 11.7436L13.0977 10.383C13.236 10.2209 13.4797 10.2014 13.642 10.3397C13.8043 10.4782 13.8236 10.7218 13.6853 10.884L12.2939 12.5161C12.2179 12.6051 12.1095 12.6516 12 12.6516Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LaptopSafeIcon;
